import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Sends a GA4 page_view on the initial render and on every client-side
 * route change. Renders nothing.
 *
 * Must sit inside the router, since useLocation requires a Router context.
 * Without this the app would report a single page_view per full page load
 * and none of the navigation that follows, which is most of an SPA session.
 */
export function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
